import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../utils/auth/authSlice";

export default configureStore({
  reducer: {
    auth: authReducer,
  },
});
